import { createFileRoute, Link } from '@tanstack/react-router'

import { CashFlowChart } from '@/features/cashflow/components/cash-flow-chart'

import { PageCard, PageLayout } from '@/components/ui/page'

export const Route = createFileRoute('/_app/report/')({
  component: Component,
})

function Component() {
  return (
    <PageLayout.Root>
      <PageLayout.Header breadcrumbs={[['/report', 'Laporan']]} />
      <PageCard.Root>
        <PageCard.Header
          title="Arus Kas"
          desc="Menampilkan pergerakan uang masuk dan keluar dari transaksi dalam periode tertentu."
          actions={
            <PageCard.HeaderActionRoot className="flex-shrink-0">
              <PageCard.HeaderAction asChild>
                <Link from={Route.fullPath} to="/report/cash-flow">
                  Lihat laporan
                </Link>
              </PageCard.HeaderAction>
            </PageCard.HeaderActionRoot>
          }
        />
        <PageCard.Content>
          <PageCard.ContentSection>
            <div className="col-span-full">
              <CashFlowChart />
            </div>
          </PageCard.ContentSection>
        </PageCard.Content>
      </PageCard.Root>
    </PageLayout.Root>
  )
}
